import OnlinePaymentTransactionUpdatedModelBase from '../_generated/modelBases/online-payment-transaction-updated-model-base';

export default class OnlinePaymentTransactionUpdatedModel extends OnlinePaymentTransactionUpdatedModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
